<template>
  <div v-if="text" class="mr-message">
    <van-notice-bar color="#FF8100" background="#fff2e5" left-icon="volume-o" scrollable :text="text" style="height: 30px;"></van-notice-bar>
  </div>
</template>

<script>
  export default {
    name: 'MrMessage',
    props: {
      text: {
        type: String,
        default: () => ''
      }
    }
  }
</script>

<style lang="scss" scoped>
.mr-message{
  margin: 0 15px;
  border-radius: 18px;
  overflow: hidden;
}
</style>
